import { KeycloakService } from 'keycloak-angular';
import { DateTime } from 'luxon';

export const getRefreshTokenExpiresDateTime = (keycloakService: KeycloakService): DateTime | null => {
  const keycloakInstance = keycloakService.getKeycloakInstance();
  return keycloakInstance.refreshTokenParsed?.exp
    ? DateTime.fromMillis((keycloakInstance.refreshTokenParsed.exp + (keycloakInstance.timeSkew ?? 0)) * 1000)
    : null;
};
